// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_investigation_status_enum */
var FermentationInvestigationStatusEnum;
(function (FermentationInvestigationStatusEnum) {
    FermentationInvestigationStatusEnum["OPEN"] = "OPEN";
    FermentationInvestigationStatusEnum["CLOSED"] = "CLOSED";
})(FermentationInvestigationStatusEnum || (FermentationInvestigationStatusEnum = {}));
;
export default FermentationInvestigationStatusEnum;
/** Zod schema for fermentation_investigation_status_enum */
export const fermentationInvestigationStatusEnum = z.nativeEnum(FermentationInvestigationStatusEnum);
//# sourceMappingURL=FermentationInvestigationStatusEnum.js.map